// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"singlePublicationSideNav_blockWrapper__1zcV1","blockLink":"singlePublicationSideNav_blockLink__Rmie_","blockIcon":"singlePublicationSideNav_blockIcon__1BAZq"};